import React from 'react'
import jwtDecode from 'jwt-decode'
import { useSelector } from 'react-redux'
import useRouter from 'utils/useRouter'
import { toast } from 'react-toastify'
import { getScreenByToken, verifyTokenRole } from 'config/tokenRouter'
import history from 'utils/history'

const ProtectedRoute = ({
  parent: Parent,
  child,
  level,
  redirectRoute = '/login',
  ...rest
}) => {
  const { token } = useSelector((state) => state.token)
  const router = useRouter()

  function redirect() {
    router.history.replace({
      pathname: redirectRoute,
      state: { from: router.location.pathname },
    })
  }

  if (token) {
    const decoded = jwtDecode(token)
    const identity = getScreenByToken(token)
    if (level) {
      if (level !== identity?.level) {
        toast.error('Acesso não autorizado!')
        verifyTokenRole(token, history)
      }
    }
    const current_time = Date.now() / 1000
    if (decoded.exp < current_time) {
      toast.warn('Seu acesso expirou, faça login novamente.')
      redirect()
      return null
    }

    return <Parent component={child} {...rest} />
  }

  toast.error('Acesso não autorizado!')
  redirect()
  return null
}

export default ProtectedRoute
